module.exports = __webpack_public_path__ + "img/fountain.b0f29baa.svg";